export const BRAZIL_PHONE_VALIDATION_REGEX = /^[0-9]{10,11}$/;
